import React from 'react';
import { Link } from 'react-router';
import { config } from 'config';

import profile from '../../static/img/profile.jpeg';

class GetInTouch extends React.Component {
  render() {
    return (
      <section id="contact-section" className="contact-section section">
        <h2 className="section-title">Get in Touch</h2>
        <div className="intro">
          <img className="profile-image" src={profile} alt="" />
          <div className="dialog">
            <p>
              My name is Alex Maroz.
              I’m Microsoft Certified Professional with over 20 years of experience
              in development of large-scale web systems,
              with solid experience in Content Management System development.</p>
            <p><strong>I can help with the following:</strong></p>
            <ul className="list-unstyled service-list">
              <li>
                <i className="fa fa-check" aria-hidden="true" />
                Front-end development with ReactJS/VueJS
              </li>
              <li>
                <i className="fa fa-check" aria-hidden="true" />
                Back-end development with NodeJS, Asp.Net Core and Golang
              </li>
              <li>
                <i className="fa fa-check" aria-hidden="true" />
                UI development
              </li>
              <li>
                <i className="fa fa-check" aria-hidden="true" />
                UX prototyping
              </li>
            </ul>
            <p>Drop me a line at <Link to={`mailto:${config.siteEmailUrl}`}>{config.siteEmailUrl}</Link></p>
            <ul className="social list-inline">
              <li>
                <Link to={config.siteLinkedInUrl}>
                  <i className="fa fa-linkedin" aria-hidden="true" />
                </Link>
              </li>
              <li>
                <Link to={config.siteGithubUrl}>
                  <i className="fa fa-github-alt" aria-hidden="true" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

GetInTouch.propTypes = {
  route: React.PropTypes.object,
};

export default GetInTouch;



// WEBPACK FOOTER //
// ../components/Blocks/GetInTouch.jsx